<template>
    <div data-toggle="lists">
        <b-input-group class="input-group-merge">
            <b-form-input
                v-model.trim="query"
                @change="fetchCustomers()"
                :autofocus="true"
                class="nofade form-control-prepended form-control-appended"
                :placeholder="$t('Search client')"
            ></b-form-input>

            <div class="input-group-prepend">
                <div class="input-group-text" style="max-height:40.5px;">
                    <span class="fe fe-loader spin-icon text-muted" v-if="areDataLoading"></span>
                    <span class="fe fe-x text-muted" v-else-if="query" @click="query=null"></span>
                    <span class="fe fe-search text-muted" v-else></span>
                </div>
            </div>
            <b-input-group-append>
                <b-button variant="info" @click="openModal({id:'CustomerModal', model:customer})">
                    <i class="fe fe-plus"></i>
                </b-button>
            </b-input-group-append>
        </b-input-group>
        <ul class="list-group list mt-2 pointer" style="max-height:200px; overflow-y:scroll" v-if="customers">
            <li
                class="list-group-item py-2"
                :class="{'active':index == currentFocus}"
                v-for="(customer, index) in customers"
                :key="index"
                @click="updateValue(customer)"
            >
                <customer-card :customer="customer" balance></customer-card>
            </li>
        </ul>
    </div>
</template>

<script>
import debounce from 'lodash/debounce';
import Avatar from '@/components/Avatar.vue'
import { mapActions, mapGetters, mapState } from 'vuex';
import { modalMixins } from '@/mixins/modal.js'
import CustomerCard from "@/components/CustomerCard";


export default {
    components: {
        CustomerCard,
        Avatar,
    },
    props: {
        fetchQuery: { default: () => ({}) }
    },
    mixins: [modalMixins],
    data() {
        return {
            query: null,
            currentFocus: 0,
            customer: {},
            customers: [],
            params: {
                query: {
                    $limit: 3,
                    $sort: {
                        createdAt: -1
                    }
                }
            }
        }
    },
    computed: {
        ...mapState('customers', { areDataLoading: 'isFindPending' })
    },
    destroyed() {
        window.removeEventListener("keyup", this.listener, true);
    },
    created() {
        this.fetchCustomers();
        window.addEventListener('keyup', this.listener, true);
    },
    watch: {
        query: debounce(async function (newVal) {
            if (this.pendingPromise)
                await this.pendingPromise
            if (newVal) {
                this.params.query.$limit = 10;
                this.params.query = { ...this.params.query, ...this.$customersSearch(newVal) };
            } else {
                delete this.params.query.$or;
                delete this.params.query.first_name;
                delete this.params.query.last_name;
                delete this.params.query.phone;
                this.params.query.$limit = 3;
            }
            this.pendingPromise = this.fetchCustomers();
        }, 300),

    },
    methods: {
        ...mapActions('customers', { findCustomers: 'find' }),

        listener(event) {
            if (event.keyCode == 40) this.currentFocus++;
            else if (event.keyCode == 38) this.currentFocus--;
            else if (event.keyCode == 13) {
                this.updateValue(this.customers[this.currentFocus]);
            }
            if (this.currentFocus < 0) this.currentFocus = this.customers.length - 1;
            if (this.currentFocus > this.customers.length - 1) this.currentFocus = 0;

        },
        updateValue(value) {
            this.query = '';
            this.$emit('input', value._id);
        },

        fetchCustomers() {
            Object.assign(this.params.query, this.fetchQuery)
            return this.findCustomers(this.params).then(data => {
                this.customers = data.data
            })
        }
    }
}
</script>

<style>

</style>
